<template>
<div>
  <div class="h-100" ref="fadeWhenModelOpen">
    <div class="d-inline-flex w-100" style="height:45px;">
        <div class="justify-content-start">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb comm-settings-top-nav m-0">
                  <li>
                     <back-button  v-on:click.native="changeComponent('show-user-groups')" style="position: relative;bottom: 8px;inset-inline-start:5px;"></back-button>
                  </li>
                    <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{seletedUserGroupName}}</li>
                </ol>
            </nav>
        </div>
        </div>
    <nav class="navbar navbar-expand-lg p-0">
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div class="navbar-nav w-100 top-nav-bar" style="display:flex;justify-content:space-around;">
                <a class="nav-item nav-link" v-on:click="selectedUserGroupComponent = 'user-group-info';" :class='(selectedUserGroupComponent === "user-group-info")?"active":"inactive"'>{{$t('Basic Info')}}<span class="sr-only">(current)</span></a>
                <a class="nav-item nav-link" v-on:click="selectedUserGroupComponent = 'user-group-privileges'" :class='(selectedUserGroupComponent === "user-group-privileges")?"active":"inactive"'>{{$t('Privileges')}}</a>
                <a class="nav-item nav-link" v-on:click="selectedUserGroupComponent = 'user-group-bin-permissions'" :class='(selectedUserGroupComponent === "user-group-bin-permissions")?"active":"inactive"'>{{$t('Bin Permissions')}}</a>
                <a class="nav-item nav-link" v-on:click="selectedUserGroupComponent ='user-group-catalog-permissions'" :class='(selectedUserGroupComponent === "user-group-catalog-permissions")?"active":"inactive"'>{{$t('Catalog Permissions')}}</a>
                <a class="nav-item nav-link" v-if="isCatalogDisplayEnabled" v-on:click="selectedUserGroupComponent ='fusion-mobile-catalog-preference'" :class='(selectedUserGroupComponent === "fusion-mobile-catalog-preference")?"active":"inactive"'>{{$t('Mobile Catalogs Display')}}</a>
                <a class="nav-item nav-link" v-on:click="selectedUserGroupComponent = 'user-group-Retrieval-settings'" :class='(selectedUserGroupComponent === "user-group-Retrieval-settings")?"active":"inactive"'>{{$t('Retrieval Settings')}}</a>
            </div>
        </div>
    </nav>
    <template v-if="selectedUserGroupComponent == 'user-group-info'" style="background:#161616">
      <div class="height-set">
        <table class="table users-basic-info-table" style="background: transparent">
          <thead style="color: #eee">
            <tr>
              <th scope="col" style="width: 11%"></th>
              <th scope="col" style="width: 80%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="key-div">{{$t('Group Name')}}</td>
              <td class="value-div d-inline-flex float-left m-0" style="padding-inline-start:0px !important">
                <div class="w-100 d-inline-flex">
                  <div class="d-inline-flex">
                    <span v-show="!isEditing('group_name')" style="padding-top: 9px;">
                      {{ selectedUserGroupInfo.group_name }}
                    </span>
                    
                    <svg
                      v-show="!isEditing('group_name') && selectedUserGroupID"
                      @click="copyGroupId"
                      class="bi bi-copy copy-group-id-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16">
                      <title>{{$t('Copy Group ID')}}</title>
                      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                    </svg>
                    
                    <edit-icon @click.native="editBasicInfoField('group_name')" v-show="!isEditing('group_name')" class="editIcon"></edit-icon>
                  </div>
                  <input
                      minlength="3"
                      type="text"
                      v-model="postData.group_name"
                      v-show="isEditing('group_name')"
                      class="rounded text-light comm-input-field-style"
                      id="input_field_focus"
                      required
                      style="padding-inline-start:5px;"
                    />
                    <div v-show="isEditing('group_name')">
                      <div class="d-flex" style="padding-top: 9px;">
                        <save-icon
                          @click.native="updateUserGroup('group_name')"
                        ></save-icon>
                        <cancel-icon @click.native="cancelBasicInfoField()"></cancel-icon>
                      </div>
                    </div>
                </div>
              </td>
            </tr>
            <tr v-if="globalSettingsFromStartup.enable_department" >
              <td class="key-div" style="vertical-align:top">{{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</td>
              <td class="value-div w-30 float-left m-0" style="padding-inline-start:0px !important;width:60%">
                <div style="display: inline-flex" class="w-100">
                  <div class="w-100">
                    <div v-if="!isEditing('department')" class="d-inline-flex"  style="flex-flow: wrap;">
                      <template v-if="!isEditing('department') && selectedUserGroupInfo.department_info != undefined && selectedUserGroupInfo.department_info.length">
                        <span class="selected-tags-style" style="padding-inline-end: 10px !important;" v-for="dInfo in selectedUserGroupInfo.department_info" :key="dInfo._id">
                          <span v-if="'logo' in dInfo && dInfo.logo" class="img-span"><img :src="getProxyConvertedURL(dInfo.logo)" /></span>
                          {{dInfo.name}}</span>
                      </template>
                      <span v-else-if="!isEditing('department')" class="empty-field-text-styles">NONE</span>
                      <edit-icon
                        @click.native="editBasicInfoField('department')"
                        v-if="!isEditing('department')"
                        class="editIcon"
                      ></edit-icon>
                    </div>
                    <div v-if="isEditing('department')" style="display:flex;align-items:center">
                      <div style="display:flex !important;flex-direction:column;width:100%;justify-content:center;align-items: flex-end;">
                        <departmentsCommonComponent :isMultiselectDropdown='true' :inEditMode='true' :selectedProject="selectedUserGroupInfo.department_info" @updateSelectedDepartments="updateSelectedDepartments"></departmentsCommonComponent>
                        <span @click="openManageDepartment = true" class="manage-department-styles">Manage {{globalSettingsFromStartup.department_alias &&  globalSettingsFromStartup.department_alias.alias_name?globalSettingsFromStartup.department_alias.alias_name:"Department"}}</span>
                      </div>
                        <div>
                          <div class="d-flex" style="justify-content:center;position:relative;bottom:10px">
                            <save-icon
                              @click.native="updateUserGroup('department')"
                            ></save-icon>
                            <cancel-icon
                              @click.native="cancelBasicInfoField()"
                            ></cancel-icon>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="group-members">
          <!-- <div class="search-bar-comm-style pt-2 col-md-9" style="display: block;">
              <input
                type="text"
                v-model="searchUser"
                class="rounded text-light search-bar"
                placeholder="Search user"/>
          </div> -->
          <div style="overflow:auto;height:90%" class="w-100">
                  <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;padding:14px;float:inline-start">
                    <div style="margin: 5px 19px 0px 19px;" v-on:click="addUserFromBrowse()"><div class="add-user-icon-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-person-plus-fill" viewBox="0 0 16 16">
                        <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                        <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                      </svg></div>
                      <div>{{$t('Add user')}}</div>
                      </div>
                      <template v-for="tagId in filteredUsers">
                      <div  :key="tagId"  v-if="selctedserNameIdList[tagId] != undefined" class="comm-tags-class" style="width:100px;padding: 5px;margin-bottom: 8px;position:relative">
                        <div v-if="Object.keys(selctedserNameIdList[tagId]).includes('profile_image') && !['undefined',null].includes(selctedserNameIdList[tagId].profile_image) && selctedserNameIdList[tagId].profile_image" class='user-name-or-image'>
                            <img :src="getProxyConvertedURL(selctedserNameIdList[tagId].profile_image)" @error="replaceWithUserIcon($event,selctedserNameIdList[tagId].username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                        </div>
                        <div v-else class="user-name-or-image" :title="selctedserNameIdList[tagId].username" :style="style(selctedserNameIdList[tagId].username)" >{{selctedserNameIdList[tagId].username.split("")[0]}}</div>
                        <div style="text-align:center;word-break: break-all;" >{{selctedserNameIdList[tagId].username}}</div>
                        <cancel-icon class="delete-user-icon" @click.native="deleteUserFromGroup(tagId, selctedserNameIdList[tagId].username)"></cancel-icon>
                      </div>
                      </template>
                  </div>   
            </div>
        </div>
      </div>
    </template>
  </div>
    <user-group-privileges v-if="selectedUserGroupComponent == 'user-group-privileges'" v-bind="currentProperties" :newUserGroup=false class="h-100%"></user-group-privileges>
    <user-group-bin-permissions v-if="selectedUserGroupComponent == 'user-group-bin-permissions'" v-bind="currentProperties" :newUserGroup=false :binTypesFilter="['asset','deployment']"></user-group-bin-permissions>
    <user-group-catalog-permissions v-if="selectedUserGroupComponent == 'user-group-catalog-permissions'" v-bind="currentProperties" :newUserGroup=false></user-group-catalog-permissions>
    <fusion-mobile-catalog-preference v-if="selectedUserGroupComponent == 'fusion-mobile-catalog-preference'" v-bind="currentProperties" :newUserGroup=false></fusion-mobile-catalog-preference>
    <user-group-Retrieval-settings v-if="selectedUserGroupComponent == 'user-group-Retrieval-settings'" v-bind="currentProperties" :newUserGroup=false></user-group-Retrieval-settings>
    <add-user-browse v-if='isUsersBrowseEnabled' :selectedUserGroupID='selectedUserGroupID' :isEditGroup='true' :userNameIdMap='selctedserNameIdList' :selectedIds='selectedUserGroupInfo.user_list' @close='handleUserSelection'></add-user-browse>
    <ManageDepartments v-if="openManageDepartment" @close="openManageDepartment = false"></ManageDepartments>
  </div>
</template>


<script>
import { mapActions,mapMutations } from "vuex";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import Utils from "../../components.utils.js";
import UserGroupPrivileges from "../userGroups/UserGroupPrivileges.vue"
import UserGroupBinPermissions from "../userGroups/UserGroupBinPermissions.vue"
import CatalogPermissions from "../userGroups/UserGroupCatalogPermissions.vue"
import GroupRetrievalSettings from "./GroupRetrieveConfiguration.vue"
import BackButton from "../core/backButton.vue";
import AddUserFromBrowse from "./AddUserFromBrowse.vue";
import {NotifierConstants} from "../../components.constants.js";
import FusionMobileCatalogPreference from './FusionMobileCatalogPreference.vue';
import departmentsCommonComponent from "../miscellaneous/departmentsCommonComponent.vue";
import ManageDepartments from "../users/ManageDepartments.vue";

export default {
  data() {
    return {
      postData: {},
      selectedUserGroupComponent:'user-group-info',
      editingKey:"",
      selectedUserGroupInfo: {},
      userList: [],
      isUsersBrowseEnabled:false,
      selctedserNameIdList:{},
      selectedUserIdList:[],
      userListFromAutocomplete:[],
      usernameWithIdList:[],
      searchKey:"",
      searchUser:null,
      openManageDepartment:false,
    };
  },
  props: ["selectedUserGroupID","seletedUserGroupName"],
  provide() {
    return { selectedUserGroupInfo: this.selectedUserGroupInfo };
  },
  components: {
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "user-group-privileges": UserGroupPrivileges,
    "user-group-bin-permissions": UserGroupBinPermissions,
    "user-group-catalog-permissions": CatalogPermissions,
    "user-group-Retrieval-settings": GroupRetrievalSettings,
    "back-button":BackButton,
    "add-user-browse":AddUserFromBrowse,
    "fusion-mobile-catalog-preference": FusionMobileCatalogPreference,
    departmentsCommonComponent,
    ManageDepartments,
  },
  computed:{
    globalSettingsFromStartup:{
      get(){
        return this.$store.state.startUpData.startUpDataDetails;
      }
    },
    currentProperties() {
        return { selectedUserGroupID: this.selectedUserGroupID, selectedUserGroupInfo: this.selectedUserGroupInfo };
      },
    filteredUsers() {
      if(this.searchUser != null){
        if (!this.selectedUserGroupInfo.user_list.length) {
            return [];
          }
          return this.selectedUserGroupInfo.user_list.filter((item) => {
            const userName = this.selctedserNameIdList[item].toLowerCase();
            const searchTerm = this.searchUser.toLowerCase();
            return userName.includes(searchTerm);
          });
        }else{
          return this.selectedUserGroupInfo.user_list;
        }
      },
     
     isCatalogDisplayEnabled:{
        get(){
           if(!Object.prototype.hasOwnProperty.call(this.$store.state.startUpData.startUpDataDetails,'enable_display_catalogs')){
              return false;
           }
           if(Object.prototype.hasOwnProperty.call(this.$store.state.startUpData.startUpDataDetails,'enable_display_catalogs')){
              return this.$store.state.startUpData.startUpDataDetails.enable_display_catalogs;
           }
           return false;
        }
     }
  },
  methods: {
    getProxyConvertedURL(url){
        return Utils.convertToLoginIPDomainName(url);
    },
    async copyGroupId() {
      if (!this.selectedUserGroupID) {
        this.$toast.error(this.$t("Group ID not available"));
        return;
      }

      try {
        await navigator.clipboard.writeText(this.selectedUserGroupID);
        this.$toast.info(this.$t("Group ID copied"));
      } catch (error) {
        const input = document.createElement("textarea");
        input.value = this.selectedUserGroupID;
        input.style.position = "fixed";
        input.style.opacity = "0";

        document.body.appendChild(input);
        input.select();

        const copied = document.execCommand("copy");
        document.body.removeChild(input);

        copied
          ? this.$toast.info(this.$t("Group ID copied"))
          : this.$toast.error(this.$t("Failed to copy group ID"));
      }
    },
    updateSelectedDepartments(values){
      this.selectedUserGroupInfo.department_info = values;
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    getProfileImageOfUser(image){
      image = Utils.convertToLoginIPDomainName(image);
      let defaultImage = Utils.getNoThumbnailImg()
        let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' onerror="this.src='+defaultImage+'; this.onerror = null"  style="width:100%;height:100%;border-radius:6px">'
        return profileImageTag;
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    cancelBasicInfoField() {
      this.editingKey = null;
    },
    editBasicInfoField(keyName) {
      this.editingKey = keyName;
    },
    isEditing(keyName) {
      return keyName === this.editingKey;
    },
    addUserFromBrowse(){
      this.isUsersBrowseEnabled = true;
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
    },
    handleUserSelection(){
      this.isUsersBrowseEnabled = false;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      setTimeout(() => {
        this.userGroupDataFromServer();
      }, 100);
    },
    updateNavBarComponent(showGroupAddButton, groupName){
          this.showUserGroupAddButton = showGroupAddButton
          this.seletedUserGroupName = groupName
      },
    deleteUserFromGroup(userId, userName){
      if (confirm(`Are You sure you want to remove the user "${userName}" from group?`)) {
        this.selectedUserIdList.splice(this.selectedUserIdList.indexOf(userId),1);
        this.updateUserGroup("user_list")
      }
    },
    getOnlyIdsArr(arrayOfDictionaries){
        return arrayOfDictionaries.map(item => item._id);
    },
    updateUserGroup(field) {
      let payload = {};
      if(field == 'group_name' &&
      (typeof this.postData[field] == "undefined" ||
      this.postData[field].trim().length <= 0)){
        alert("Please add a valid group name. ")
        return
      }
      else if(field == 'user_list'){
        this.postData[field] = this.selectedUserIdList
        // if(typeof this.postData[field] == "undefined" ||
        //   this.postData[field].length <= 0){
        //   alert("Please add user(s) to group. ");
        //   return
        // }
      }
      payload[field] = this.postData[field];
      if(field == "department"){
        console.log("this.selectedUserGroupInfo.department_info",this.selectedUserGroupInfo.department_info)
        payload[field] = this.getOnlyIdsArr(this.selectedUserGroupInfo.department_info);
      }
      payload.params = { _id: this.selectedUserGroupID };
      this.updateExistingUserGroup(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)) {
          if (data.message.includes("Failed")) {
            this.$toast.warning(data.message);
          } else {
            this.$toast.success(data.message);
            this.userGroupDataFromServer();
          }
        } else {
          this.$toast.error(data.message);
        }
      });
      this.cancelBasicInfoField()
    },
    usernameAndIdDictionaryCreater(data){
      for (let i = 0; i < data.length; ++i) {
        let eachInfo = data[i];
        this.usernameWithIdList.push({_id:eachInfo.user_id,username:eachInfo.username})
        this.selctedserNameIdList[eachInfo.user_id] = eachInfo
      }
    },
    changeComponent(comp){
            this.$emit("changeSelectedComponent", comp);
            let enableAddGroupButton = false
            if(this.tableType == 'show-user-groups'){
                    this.$emit("changeSelectedComponent",comp)
                    this.$refs.userGroupRef.changeSelectedComponent(comp)
                if(comp == "show-user-groups"){
                    enableAddGroupButton = true
                }else if(comp == "user-group-info"){
                    enableAddGroupButton = true
                }
            }
            this.showUserGroupAddButton = enableAddGroupButton
      },
      getusersOnKeyup(option){
        let payload = {}
          payload.params = {username:option}
          this.getUsersAutoComplitionFromServer(payload).then((data) => {
            if(data["users"].length){
              this.userListFromAutocomplete = data["users"];
            }else{
              this.userListFromAutocomplete = [];
            }
          });
      },
      userGroupDataFromServer(){
        let payload = {};
          payload.params = { _id: this.selectedUserGroupID };
          this.getUserGroupInfoFromServer(payload).then((resp) => {
            this.selectedUserGroupInfo = resp.user_group;
            this.postData = this.selectedUserGroupInfo
            this.selectedUserIdList = resp.user_group.user_list;
            this.usernameAndIdDictionaryCreater(resp.user_map);
          });
      },
    handleUserGroupsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let group_info = notification.message;
        if(group_info && group_info._id == this.selectedUserGroupID){
          if(notification.message_type == NotifierConstants.userGroupRemovedNotification){
            alert(`Selected user group "${group_info.group_name}" is deleted.\nSo, reloading the page.`)
            this.changeComponent('show-user-groups');
            return
          }else{
            Object.assign(this.selectedUserGroupInfo, group_info)
            Object.assign(this.postData, group_info)
            this.$set(this.selectedUserGroupInfo, "user_list", group_info.user_list);
            if("user_map" in group_info){
              for(let eachMap of group_info.user_map){
                let indx = this.selectedUserGroupInfo.findIndex(op=>op.user_id == eachMap.user_id)
                if(indx < 0){
                  this.selectedUserGroupInfo.push(eachMap)
                }
              }
            }
          }
        }
      }
    },
    handleUsersNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let userInfo = notification.message
      if(userInfo){
        if([NotifierConstants.userRemovedNotification].includes(notification.message_type)){
          if(this.selectedUserGroupInfo.user_list.includes(userInfo._id)){
            this.selectedUserGroupInfo.user_list.splice(this.selectedUserGroupInfo.user_list.indexOf(userInfo._id))
          }
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[ NotifierConstants.userGroupModifiedNotification, NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,
            parent:"UserGroupInfo"})
      this.addWSEventListener({
            eventname:[NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"UserGroupInfo"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[ NotifierConstants.userGroupModifiedNotification, NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,
            parent:"UserGroupInfo"})
      this.removeWSEventListener({
            eventname:[NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"UserGroupInfo"})
    },
    ...mapActions("userGroups", ["getUserGroupInfoFromServer", "updateExistingUserGroup"]),
    ...mapActions("users", ["getAllUsersFromServer","getUsersAutoComplitionFromServer"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  created() {
    this.registerforWebsocketNotifications()
    this.userGroupDataFromServer()
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  },
};
</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;


.search-bar{
  background: $primary-background!important;
  height:40px;
  width: 250px !important;
  float: inline-start;
  padding-inline-start: 12px;
  padding-bottom: 2px;
  border:$border-color !important;
}

.height-set{
  height: calc(100vh - 170px);
  background: $primary-background;
  .group-name{
    text-align: start;
    padding:16px 3%;
    font-size:27px;
    display:flex;
  }
  .group-members{
    height: calc(100% - 90px);
  }
}

.add-user-icon-wrapper{
    height: 59px;
    width: 60px;
    line-height: 54px;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color; 
}

.add-user-icon-wrapper:hover{
    color: $add-button-text-color-hover;
    border: 1px solid $add-button-border-on-hover; 
}

.editIcon {
    margin-inline-start: 9px;
    margin-top: 7px
}

.comm-input-field-style{
    background: $primary-background!important;
    height:40px;
    width: 100% !important;
    float: inline-start;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color!important;
}

.search-bar-comm-style{
  padding-inline-start:3%;
  height:60px;
}

#contact_number_input::-webkit-outer-spin-button,
#contact_number_input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: start;
      color: $dull-text-color;
      padding-inline-start: 3% !important;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      width: 40%;
      font-weight: 500;
      input,select{
        padding-inline-start:4px;
      }
    }
  }
}

.activeclass {
  color: $active-blue;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

.btn {
  font-size: $input-field-and-label-font-size !important;
  height: 100%;
}

.custom-control-label::before {
  background-color: $primary-background;
}

table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.disablefield {
  border: none !important;
  pointer-events: none;
}

.force-logout {
  position: relative;
  inset-inline-start:5px;
  bottom: 4px;
}
.force-logout:hover {
  text-decoration: underline;
}
.activestatus {
  color: $active-green-color !important;
}
.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
}
.top-nav-bar{
    background: $primary-background;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.editIcon{
  visibility:hidden;
}

.group-name:hover .editIcon{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

  .view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: $border-color!important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
  }
  

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}
.user-name-or-image{
    height: 60px;
    width: 60px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 56px;
    text-transform: uppercase;
    margin: 0 auto;
    font-size: 30px;
}

.delete-user-icon{
  visibility: hidden;
}

.comm-tags-class:hover .delete-user-icon{
  visibility: visible;
}

.delete-user-icon{
  position: absolute;
  inset-inline-end: 11px;
  top: 1px;
  height: 23px;
  width: 23px;
  border: $border-color;
  background: $secondary-background-color;
  border-radius: 30px;
  color: $text-color;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

::v-deep {
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color;
        display: flex;
        flex-direction: column;
        align-items: baseline;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:auto;
    }
    .multiselect__option--selected{
        background:  $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid  $bg-color-on-hover !important;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
}

.manage-department-styles{
  float: inline-start;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  color: #909b43cf;
  width: 35%;
  text-align: end;
}

.manage-department-styles:hover{
  text-decoration: underline;
}

.selected-tags-style{
  background: $bg-color-on-hover;
  border: 1px solid #363636;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 25px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 2px !important;
  padding-inline-end: 4px !important;
  margin-bottom: 4px !important;
  align-items: center !important;
  .remove-tag{
      line-height:18px;
      color: #858585;
  }
 }


span.img-span{
  width: 40px;
  height: 40px;
  display: inline-flex;
  padding: 2px !important;
  margin-inline-end:4px;
  align-items: center;
      img{
          max-width: 100%;
          max-height: 100%;
          border-radius: 4px;
          object-fit: contain;
          display: inline-block;
      }
  }
  
  .empty-field-text-styles{
    color:#7a7a7a;
  }

  .copy-group-id-icon {
    margin-inline-start: 9px;
    margin-top: 9px;
    cursor: pointer;
    color: #9c9c9c;
  }
  
  .copy-group-id-icon:hover {
    color: $active-blue;
  }

</style>